import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=73b93d5c&"
import script from "./Inventario.vue?vue&type=script&lang=js&"
export * from "./Inventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports